module.exports = __webpack_public_path__ + "static/media/chart1Icon.43bbdeff.svg";